import { Modal } from "@zapier/design-system-beta";
import { useAtomValue, useSetAtom } from "jotai";
import {
  emitEventOnAICopilotStartAtom,
  showAIStreamCreateModalAtom,
  zslExecutionFailedErrorMsgAtom,
  togglesAtomResettable,
} from "@zapier/canvas-state";
import classNames from "classnames";

import { showWelcomeModalAtom } from "../../atoms/showWelcomeModalAtom";
import {
  isStreamingZslAtom,
  isPromptToZslCompleteAtom,
  promptToZslErrorAtom,
} from "../../atoms/streamingStatusAtoms";
import { handleCloseModalCommand } from "../../atoms/handleCloseModalCommand";
import { useStreamingPrompt } from "../../hooks/useStreamingPrompt";

import { WelcomeModalContent } from "../WelcomeModalContent";

import { AIStreamModalContent } from "./AIStreamModalContent";
import styles from "./AIStreamCreateModal.module.css";
import { AiPromptBox } from "../AiPromptBox/AiPromptBox";
import { useEffect } from "react";

export function AIStreamCreateModal() {
  const showWelcomeModal = useAtomValue(showWelcomeModalAtom);
  const showAIStreamCreateModal = useAtomValue(showAIStreamCreateModalAtom);
  const emitEventOnAICopilotStart = useSetAtom(emitEventOnAICopilotStartAtom);

  const zslExecutionFailed = useAtomValue(zslExecutionFailedErrorMsgAtom);

  useEffect(() => {
    // Start tracking the AI Copilot start event when the modal is opened
    emitEventOnAICopilotStart();
  }, [emitEventOnAICopilotStart]);

  const toggles = useAtomValue(togglesAtomResettable);
  const handleCloseModal = useSetAtom(handleCloseModalCommand);

  const isComplete = useAtomValue(isPromptToZslCompleteAtom);
  const error = useAtomValue(promptToZslErrorAtom);
  const isLoading = useAtomValue(isStreamingZslAtom);

  const { submitPrompt } = useStreamingPrompt();

  const renderModalContent = () => {
    if (toggles.aiDiscovery) {
      return (
        <AiPromptBox error={zslExecutionFailed} handleSubmit={submitPrompt} />
      );
    }

    if (showAIStreamCreateModal) {
      return (
        <AIStreamModalContent
          onFormSubmit={submitPrompt}
          isLoading={isLoading}
          isComplete={isComplete}
          error={error}
          handleCloseModal={handleCloseModal}
        />
      );
    }

    if (showWelcomeModal) {
      return <WelcomeModalContent handleCloseModal={handleCloseModal} />;
    }
  };

  return (
    <Modal.Root isOpen={true} onOpenChange={handleCloseModal}>
      <Modal.Content
        className={classNames({
          [styles.modalContentOverride]: showAIStreamCreateModal,
          [styles.modalContentOverrideAiDiscovery]: toggles.aiDiscovery,
        })}
        isDismissable={!isLoading}
      >
        {renderModalContent()}
      </Modal.Content>
    </Modal.Root>
  );
}
